import React from "react";
import "./Cps_subject_SubTopic.scss";

import CpsSubjectTopicContent from "./cpsSubjectTopicContent/CpsSubjectSubTopicContent";
import PersistentSidebarLayout from "../../../../../components/PersistentSidebarLayout/PersistentSidebarLayout";

import LoaderPopUp from "../../../../../components/loader/loader";
import { connect } from "react-redux";
import Footer_component from "../../../structure_components/desktop_screens/footer_component/Footer_component";

const Cps_subject_SubTopic = (props) => {
  let { loader, userPreference } = props;
  return (
    <PersistentSidebarLayout>
      <div className="PyqSubjectTopicWrapper">
        <div className="PyqSubjectTopicInrWrpr">
          <CpsSubjectTopicContent userPreference={userPreference} />
        </div>
      </div>
      <Footer_component />
      {loader && <LoaderPopUp />}
    </PersistentSidebarLayout>
  );
};
const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};
export default connect(mapStateToProps)(Cps_subject_SubTopic);
